import React, { Component } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import API from './API';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import ValidationMessage from '../ValidationMessage';

export default class ResourceField extends Component {
  static cache = {};

  defaultSelected = [];
  state = {
    isLoading: false,
    hasInputText: false,
    options: []
  };

  constructor(props) {
    super(props);

    this.definition = props.definitions[props.name];

    if (!ResourceField.cache[this.props.name]) {
      ResourceField.cache[this.props.name] = {};
    }

    const updateValue = this.props.update && this.props.update[this.props.name];
    if (updateValue) {
      const updateValues = this.definition.multiple ? updateValue : [updateValue];
      this.defaultSelected = updateValues.map((value) => ({
        identifier: value[this.definition.resource.identifier],
        name: this.definition.resource.value(value)
      }));
    }
  }

  onSearch(query) {
    this.setState({ isLoading: true });
    const params = '?q=' + encodeURIComponent(query) + '&' + this.definition.resource.query;
    new API()
      .fetch(
        'autocomplete/' + this.definition.resource.name + '.json' + params,
        'GET',
        undefined,
        'application/json',
        { public: this.definition.resource.public }
      )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          isLoading: false,
          options: this.getOptions(data)
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false,
          options: []
        });
      });
  }

  componentDidUpdate() {
    const value = this.props.values[this.props.name];
    const isEmpty = this.definition.multiple ? value.length === 0 : value === '';
    if (!this.state.hasInputText && isEmpty) {
      this.typeahead.getInstance().clear();
    }
  }

  onChange(selected) {
    const value = this.definition.multiple
      ? selected.map((option) => option.identifier)
      : selected.length === 1
        ? selected[0].identifier
        : '';
    selected.forEach((option) => {
      ResourceField.cache[this.props.name][option.identifier] = option.name;
    });
    this.props.setFieldValue(this.props.name, value);
    this.setState({
      hasInputText: false
    });
  }

  onInputChange(text) {
    this.setState({
      hasInputText: true
    });
  }

  onBlur(event) {
    const value = this.props.values[this.props.name];
    const isEmpty = this.definition.multiple ? value.length === 0 : value === '';
    if (isEmpty || (!this.definition.multiple && event.target.value === '')) {
      this.typeahead.getInstance().clear();
    }
  }

  getOptions(data) {
    return data.map((resource) => ({
      identifier: resource[this.definition.resource.identifier],
      name: this.definition.resource.value(resource)
    }));
  }

  render() {
    const error = <ValidationMessage>{this.props.errors[this.props.name]}</ValidationMessage>;

    return (
      <div className={`form-group dropdown ${this.props.className}`}>
        <label htmlFor={this.props.name}>{this.definition.title}</label>
        {this.renderInput()}
        {this.props.helpText && <small className="form-text text-muted">{this.props.helpText}</small>}
        {this.props.touched[this.props.name] && this.props.errors[this.props.name] && error}
      </div>
    );
  }

  renderInput() {
    return (
      <AsyncTypeahead
        {...this.state}
        defaultSelected={this.defaultSelected}
        id={this.definition.resource.name}
        className={
          this.props.errors[this.props.name] && this.props.touched[this.props.name] && 'is-invalid'
        }
        autoFocus={this.props.autoFocus}
        filterBy={(option) => true}
        ref={(ref) => (this.typeahead = ref)}
        onSearch={this.onSearch.bind(this)}
        onChange={this.onChange.bind(this)}
        onInputChange={this.onInputChange.bind(this)}
        onBlur={this.onBlur.bind(this)}
        selectHintOnEnter
        multiple={this.definition.multiple === true}
        labelKey="name"
        allowNew={false}
        onFocus={(event) => event.target.select()}
        minLength={2}
        emptyLabel="Geen resultaten"
        promptText="Typ om te zoeken"
        searchText="Zoeken..."
        placeholder="Zoeken..."
      />
    );
  }
}
